import { techTheme } from 'src/features/common/app/components/theme-provider/theme';
import styled from 'styled-components';

export const StyledBadge = styled.div<{ type: string }>`
    padding: 8px 12px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    cursor: default;
    justify-content: center;
    gap: 8px;

    & svg {
        color: inherit;
    }

    ${({ type }) => {
        switch (type) {
            case 'message':
                return `background-color: ${techTheme.colors.lightGrey}; color: ${techTheme.colors.text};`;
            case 'warning':
                return `background-color: ${techTheme.colors.lightYellow}; color: ${techTheme.colors.darkYellow};`;
            case 'error':
                return `background-color: ${techTheme.colors.lightRed}; color: ${techTheme.colors.darkRed}`;
            case 'success':
                return `background-color: ${techTheme.colors.lightGreen}; color: ${techTheme.colors.darkGreen};`;
            default:
                return '';
        }
    }};
`;